import type { BuildingInteriorSpec } from "@cold-case/shared/interior-layout";
import { TILE_SIZE } from "@cold-case/shared/constants";
import Phaser from "phaser";

import { tileToWorldCenter } from "./interior-exit-world.js";

export { clueMarkerWorldPoint, playerNearClueMarker } from "./interior-exit-world.js";

const CLUE_MARKER_KEY = "interior_clue_triangle";

export function ensureClueTriangleTexture(scene: Phaser.Scene): void {
  if (scene.textures.exists(CLUE_MARKER_KEY)) return;
  const g = scene.add.graphics();
  const size = Math.round(TILE_SIZE * 0.55);
  const h = size * 0.866;
  g.fillStyle(0xffff00, 1);
  g.lineStyle(2, 0xffffaa, 1);
  g.beginPath();
  g.moveTo(size / 2, 2);
  g.lineTo(size - 2, h + 2);
  g.lineTo(2, h + 2);
  g.closePath();
  g.fillPath();
  g.strokePath();
  g.generateTexture(CLUE_MARKER_KEY, size, Math.ceil(h) + 4);
  g.destroy();
}

export function spawnClueMarker(
  scene: Phaser.Scene,
  spec: BuildingInteriorSpec,
  buildingId: string,
  onTap?: () => void
): Phaser.GameObjects.Image | null {
  const ct = spec.content_tile;
  if (!ct) return null;
  ensureClueTriangleTexture(scene);
  const { wx, wy } = tileToWorldCenter(ct.tile_x, ct.tile_y);
  const spr = scene.add.image(wx, wy, CLUE_MARKER_KEY);
  spr.setDepth(8);
  spr.setData("type", "interior_clue");
  spr.setData("building_id", buildingId);
  spr.setInteractive(
    new Phaser.Geom.Circle(0, 0, TILE_SIZE * 0.65),
    Phaser.Geom.Circle.Contains
  );
  spr.input!.cursor = "pointer";
  spr.on("pointerdown", (
    _pointer: Phaser.Input.Pointer,
    _lx: number,
    _ly: number,
    event: Phaser.Types.Input.EventData
  ) => {
    event.stopPropagation();
    if (onTap) onTap();
    else scene.registry.events.emit("interior_clue_interact", buildingId);
  });
  scene.tweens.add({
    targets: spr,
    alpha: { from: 0.55, to: 1 },
    duration: 700,
    yoyo: true,
    repeat: -1,
  });
  return spr;
}

